import React from 'react';
import {
    MediaController,
    MediaControlBar,
    MediaTimeRange,
    MediaTimeDisplay,
    MediaVolumeRange,
    MediaPlayButton,
    MediaSeekBackwardButton,
    MediaSeekForwardButton,
    MediaMuteButton,
    MediaFullscreenButton,
    MediaPlaybackRateButton,
} from 'media-chrome/react';
import { StyledMediaContainer } from '../constants/media.styled';

interface IMediaPlayerProps {
    mediaUrl: string;
    disableDownload?: boolean
}

const MediaPlayer = ({ mediaUrl, disableDownload }: IMediaPlayerProps) => {
    const mediaProps = {
        src: mediaUrl,
        style: { height: '100%', width: '100%' },
        onContextMenu: (e: React.MouseEvent) => {
            if (disableDownload) e.preventDefault();
        }
    };
    return (
        <StyledMediaContainer data-testid="media-player">
            <MediaController style={{ width: '100%', height: '100%' }}>
                <video slot="media" {...mediaProps}>
                    <track kind="captions" />
                </video>
                <MediaControlBar>
                    <MediaPlayButton />
                    <MediaSeekBackwardButton seekOffset={10} />
                    <MediaSeekForwardButton seekOffset={10} />
                    <MediaTimeRange />
                    <MediaTimeDisplay showDuration />
                    <MediaMuteButton />
                    <MediaVolumeRange />
                    <MediaPlaybackRateButton />
                    <MediaFullscreenButton />
                </MediaControlBar>
            </MediaController>
        </StyledMediaContainer>
    );
};

export default MediaPlayer;